import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  search(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "reports/search/reference" + Session.getToken();
    return instance.post(url,params);
  },
  generate(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "reports/generate/pdf" + Session.getToken();
    return instance.post(url,params);
  },
  generateEscpos(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports/generate/escpos" + Session.getToken();
    return instance.post(url,params);
  },
  generateEscposLocal(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports/generate/escpos-local" + Session.getToken();
    return instance.post(url,params);
  },
  obtenerStaffThermalPrinter() {
    var url = ConfigAPI.baseURL + "staff/thermal-printer" + Session.getToken();
    return instance.get(url);
  },
  printEscpos(url, data, rawPayload, printerName = '', addPrinterToPayload = true) {
    let endpoint = url

    if(addPrinterToPayload && printerName) {
      endpoint += (endpoint.indexOf('?') === -1 ? '?' : '&') + 'printer=' + encodeURIComponent(printerName)
    }

    if(rawPayload) {
      return instance.post(endpoint,data,{
        headers: {
          'Content-Type': 'text/plain; charset=utf-8',
        }
      });
    }

    if(addPrinterToPayload && data && typeof data === 'object') {
      data.printer = printerName
    }

    return instance.post(endpoint,data);
  },
}

export default servicesAPI;
